import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAppContext, { actions } from "../../../utils/Reducers";
import { axiosInstance } from "../../../utils/api";
import useFieldValues from "../../../utils/useFieldValues";
import axios from "axios";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { ModalConfirm } from "../../../components/Confirm";
import { Modal, Button, Form } from "react-bootstrap";
import loginLogo from "../../../images/DaehanSteel_logo.png";
import loginLogoYk from "../../../images/yksteel_logo.png";

import "../../../styles/css/login.css";

const Login = () => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");

  const LS_KEY_ID = "LS_KEY_ID";
  const LS_KEY_PW = "LS_KEY_PW";
  const LS_KEY_SAVE_ID_FLAG = "LS_KEY_SAVE_ID_FLAG";
  const [saveIDFlag, setSaveIDFlag] = useState(false);

  // 비밀번호 초기화 관련 상태
  const [showPasswordResetModal, setShowPasswordResetModal] = useState(false);
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [showPasswordChangeModal, setShowPasswordChangeModal] = useState(false);
  const [resetData, setResetData] = useState({ name: "", email: "" });
  const [verificationData, setVerificationData] = useState({ email: "", code: "" });
  const [passwordData, setPasswordData] = useState({ newPassword: "", confirmPassword: "" });
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [timer, setTimer] = useState(1800); // 30분 = 1800초
  const [isTimerExpired, setIsTimerExpired] = useState(false);
  const [errors, setErrors] = useState({});

  const INITIAL_LOGIN_FIELDS = {
    userId: "",
    password: "",
  };
  const [loginFields] = useFieldValues(INITIAL_LOGIN_FIELDS);
  const LOGIN_APP_URL = "/accounts/login.do";

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    if (userAgent.indexOf("iPhone") > -1 || userAgent.indexOf("Android") > -1) {
      navigate("/mobile/login");
    } else {
      navigate("/login");
    }

    let idFlag = JSON.parse(localStorage.getItem(LS_KEY_SAVE_ID_FLAG));
    if (idFlag !== null) setSaveIDFlag(idFlag);
    if (idFlag === false) {
      localStorage.setItem(LS_KEY_ID, "");
      localStorage.setItem(LS_KEY_PW, "");
    }
    let dataId = localStorage.getItem(LS_KEY_ID);
    let dataPw = localStorage.getItem(LS_KEY_PW);
    if (dataId !== null) setUserId(dataId);
    if (dataPw !== null) setPassword(dataPw);
  }, []);

  // 타이머 효과
  useEffect(() => {
    let interval;
    if (showVerificationModal && timer > 0 && !isTimerExpired) {
      interval = setInterval(() => {
        setTimer(prev => {
          if (prev <= 1) {
            setIsTimerExpired(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showVerificationModal, timer, isTimerExpired]);

  const { dispatch } = useAppContext();

  // 유틸리티 함수들
  const validatePassword = (password) => {
    const hasLetter = /[a-zA-Z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const isLongEnough = password.length >= 8;
    const hasConsecutiveChars = /(.)\1{2,}/.test(password);
    const hasConsecutiveNumbers = /(\d)\1{2,}/.test(password);
    
    return hasLetter && hasNumber && hasSpecial && isLongEnough && 
           !hasConsecutiveChars && !hasConsecutiveNumbers;
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const submit = async () => {
    loginFields["userId"] = userId;
    loginFields["password"] = password;

    try {
      const response = await axiosInstance.post(LOGIN_APP_URL, loginFields);
      const {
        data: { token, userInfo, code, result },
      } = response;
      //console.log(code);
      //console.log(result);
      if (code === "400") {
        // 계정 잠금 메시지 확인
        if (result && result.includes("계정 잠금 처리 상태입니다")) {
          const confirmReset = window.confirm(result + "\n등록된 이메일로 비밀번호 초기화 하시겠습니까?");
          if (confirmReset) {
            setShowPasswordResetModal(true);
          }
          return;
        } else {
          alert(result);
          return;
        }
      } else if (code === "423") {
        console.log('=== 423 계정 잠금 처리 시작 ===');
        // 계정 잠금 - 비밀번호 초기화 안내
        const confirmReset = window.confirm(result + "\n등록된 이메일로 비밀번호 초기화 하시겠습니까?");
        if (confirmReset) {
          setShowPasswordResetModal(true);
        }
        return;
      } else {
        dispatch(actions.setToken(token));
        dispatch(actions.setUserInfo(userInfo));

        if (true /* login success */) {
          if (saveIDFlag) localStorage.setItem(LS_KEY_ID, userId);
          if (saveIDFlag) localStorage.setItem(LS_KEY_PW, password);
        }

        navigate("/", { replace: true });
      }
    } catch (error) {
      if (error.response) {
        const { data: errors } = error.response;
        const _responseErrors = [];
        errors.messages &&
          errors.messages.map(({ message }) => {
            Object.entries(message).map(([key, errorMessage]) => {
              _responseErrors.push(errorMessage);
            });
          });

        for (const _responseError of _responseErrors.reverse()) {
          alert(_responseError);
          return;
        }
      } else {
        alert('로그인 중 오류가 발생했습니다.');
      }
    }
  };

  // 비밀번호 초기화 요청
  const handlePasswordResetRequest = async () => {
    setErrors({});
    
    if (!resetData.name.trim()) {
      setErrors(prev => ({ ...prev, name: '이름을 입력해주세요.' }));
      return;
    }
    if (!resetData.email.trim()) {
      setErrors(prev => ({ ...prev, email: '이메일을 입력해주세요.' }));
      return;
    }

    try {
      console.log('=== 비밀번호 초기화 요청 시작 ===');
      console.log('요청 데이터:', resetData);
      console.log('요청 URL: /accounts/requestPasswordReset.do');
      
      const response = await axiosInstance.post('/accounts/requestPasswordReset.do', resetData);
      
      console.log('응답 받음:', response);
      console.log('응답 데이터:', response.data);
      
      const { data: { code, result } } = response;
      
      if (code === "200") {
        setShowPasswordResetModal(false);
        setVerificationData({ email: resetData.email, code: '' });
        setShowVerificationModal(true);
        setTimer(1800); // 30분 리셋
        setIsTimerExpired(false);
        
        // 이메일 발송 실패 시 추가 안내
        if (result && result.includes("이메일 발송에 실패")) {
          alert(result + "\n\n개발 환경에서는 서버 콘솔에서 인증코드를 확인할 수 있습니다.");
        } else {
          alert(result || '인증코드가 이메일로 전송되었습니다.');
        }
      } else {
        alert(result || '요청 처리 중 오류가 발생했습니다.');
      }
    } catch (error) {
      console.log('=== 요청 오류 발생 ===');
      console.log('오류 객체:', error);
      console.log('오류 응답:', error.response);
      console.log('오류 메시지:', error.message);
      alert('요청 중 오류가 발생했습니다.');
    }
  };

  // 인증코드 검증
  const handleVerificationCode = async () => {
    setErrors({});
    
    if (isTimerExpired) {
      alert('인증 유효시간이 초과되었습니다.');
      return;
    }
    
    if (!verificationData.code.trim()) {
      setErrors(prev => ({ ...prev, code: '인증코드를 입력해주세요.' }));
      return;
    }

    try {
      const response = await axiosInstance.post('/accounts/verifyCode.do', verificationData);
      const { data: { code, result } } = response;
      
      if (code === "200") {
        setShowVerificationModal(false);
        setShowPasswordChangeModal(true);
      } else {
        alert(result || '인증코드 검증에 실패했습니다.');
      }
    } catch (error) {
      alert('인증코드 검증 중 오류가 발생했습니다.');
    }
  };

  // 비밀번호 변경
  const handlePasswordChange = async () => {
    setErrors({});
    
    if (!passwordData.newPassword.trim()) {
      setErrors(prev => ({ ...prev, newPassword: '새 비밀번호를 입력해주세요.' }));
      return;
    }
    if (!passwordData.confirmPassword.trim()) {
      setErrors(prev => ({ ...prev, confirmPassword: '새 비밀번호 확인을 입력해주세요.' }));
      return;
    }

    if (!validatePassword(passwordData.newPassword)) {
      alert('비밀번호는 문자, 숫자, 특수문자를 포함한 8자리 이상이어야 하며, 연속된 문자나 숫자 3개 이상을 포함할 수 없습니다.');
      return;
    }

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      alert('새 비밀번호와 새 비밀번호 확인 값이 일치하지 않습니다.');
      return;
    }

    try {
      console.log('=== 비밀번호 변경 요청 시작 ===');
      console.log('이메일:', verificationData.email);
      console.log('새 비밀번호:', passwordData.newPassword);
      console.log('요청 URL: /accounts/changePassword.do');
      
      const response = await axiosInstance.post('/accounts/changePassword.do', {
        email: verificationData.email,
        newPassword: passwordData.newPassword
      });
      
      console.log('응답 받음:', response);
      console.log('응답 데이터:', response.data);
      
      const { data: { code, result } } = response;
      
      if (code === "200") {
        alert('비밀번호가 성공적으로 변경되었습니다.');
        setShowPasswordChangeModal(false);
        // 상태 초기화
        setResetData({ name: "", email: "" });
        setVerificationData({ email: "", code: "" });
        setPasswordData({ newPassword: "", confirmPassword: "" });
        setErrors({});
        setTimer(1800);
        setIsTimerExpired(false);
        // 메인 페이지로 이동하지 않고 로그인 화면에 머물기
      } else {
        alert(result || '비밀번호 변경에 실패했습니다.');
      }
    } catch (error) {
      console.log('=== 비밀번호 변경 오류 발생 ===');
      console.log('오류 객체:', error);
      console.log('오류 응답:', error.response);
      console.log('오류 메시지:', error.message);
      alert('비밀번호 변경 중 오류가 발생했습니다.');
    }
  };

  const onKeyPress = (event) => {
    if (event.key === "Enter") {
      submit();
    }
  };

  const handleSaveIDFlag = (event) => {
    if (event.target.checked) {
      localStorage.setItem(LS_KEY_SAVE_ID_FLAG, true);
      setSaveIDFlag(true);
    } else {
      localStorage.setItem(LS_KEY_SAVE_ID_FLAG, false);
      setSaveIDFlag(false);
    }
  };

  return (
    <>
      <form>
        <div className="login_box">
          <h3>
            <img src={loginLogo} width="300" alt="LOGO" />
            <br />
            <img src={loginLogoYk} width="348" alt="yklogo" />
            <br />
            <span style={{ fontSize: "23px", fontWeight: "bold" }}>
              영상검수시스템
            </span>
          </h3>
          <div className="input_box">
            <div className="input_line">
              <label>ID</label>
              <input
                type="text"
                value={userId}
                onChange={(event) => setUserId(event.target.value)}
              />
            </div>
            <div className="input_line">
              <label>PASSWORD</label>
              <input
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                onKeyPress={onKeyPress}
              />
            </div>
            <button type="button" onClick={submit}>
              로그인
            </button>
          </div>
          <div className="id_save">
            <input
              type="checkbox"
              id="id_save"
              checked={saveIDFlag}
              onChange={handleSaveIDFlag}
            />
            <label htmlFor="id_save" style={{ marginRight: "15px" }}>
              ID/PW 저장
            </label>
          </div>
        </div>
      </form>

      {/* 비밀번호 초기화 모달 */}
      <Modal show={showPasswordResetModal} onHide={() => setShowPasswordResetModal(false)} size="sm">
        <Modal.Header closeButton>
          <Modal.Title>비밀번호 초기화</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>이름 *</Form.Label>
              <Form.Control
                type="text"
                value={resetData.name}
                onChange={(e) => setResetData(prev => ({ ...prev, name: e.target.value }))}
                placeholder="이름을 입력하세요"
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>이메일 주소 *</Form.Label>
              <Form.Control
                type="email"
                value={resetData.email}
                onChange={(e) => setResetData(prev => ({ ...prev, email: e.target.value }))}
                placeholder="이메일 주소를 입력하세요"
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPasswordResetModal(false)}>
            취소
          </Button>
          <Button variant="primary" onClick={handlePasswordResetRequest}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>

      {/* 인증코드 검증 모달 */}
      <Modal show={showVerificationModal} onHide={() => setShowVerificationModal(false)} size="sm">
        <Modal.Header closeButton>
          <Modal.Title>인증코드 입력</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>이메일 계정</Form.Label>
              <Form.Control
                type="email"
                value={verificationData.email}
                readOnly
              />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>인증코드 *</Form.Label>
              <div className="d-flex align-items-center">
                <Form.Control
                  type="text"
                  value={verificationData.code}
                  onChange={(e) => setVerificationData(prev => ({ ...prev, code: e.target.value }))}
                  placeholder="이메일로 전송된 인증코드를 입력하세요"
                  isInvalid={!!errors.code}
                  className="me-2"
                />
                <div className={`text-${isTimerExpired ? 'danger' : 'warning'} fw-bold`}>
                  {isTimerExpired ? "유효시간 초과" : formatTime(timer)}
                </div>
              </div>
              <Form.Control.Feedback type="invalid">
                {errors.code}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowVerificationModal(false)}>
            취소
          </Button>
          <Button variant="primary" onClick={handleVerificationCode}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>

      {/* 비밀번호 변경 모달 */}
      <Modal show={showPasswordChangeModal} onHide={() => setShowPasswordChangeModal(false)} size="sm">
        <Modal.Header closeButton>
          <Modal.Title>비밀번호 변경</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>새 비밀번호 *</Form.Label>
              <div className="position-relative">
                <Form.Control
                  type={showNewPassword ? "text" : "password"}
                  value={passwordData.newPassword}
                  onChange={(e) => setPasswordData(prev => ({ ...prev, newPassword: e.target.value }))}
                  placeholder="새 비밀번호를 입력하세요"
                  isInvalid={!!errors.newPassword}
                />
                <Button
                  variant="link"
                  className="position-absolute end-0 top-0 border-0 bg-transparent"
                  style={{ zIndex: 10 }}
                  onClick={() => setShowNewPassword(!showNewPassword)}
                >
                  <i className={`fas ${showNewPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </Button>
              </div>
              <Form.Text className="text-danger" style={{ fontSize: '0.7rem' }}>
                1. 문자, 숫자, 특수문자 포함, 8자리 이상<br/>
                2. 연속된 문자 3개 또는 숫자 3개 금지<br/>
                3. 직전 비밀번호 사용불가
              </Form.Text>
              <Form.Control.Feedback type="invalid">
                {errors.newPassword}
              </Form.Control.Feedback>
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>새 비밀번호 확인 *</Form.Label>
              <div className="position-relative">
                <Form.Control
                  type={showConfirmPassword ? "text" : "password"}
                  value={passwordData.confirmPassword}
                  onChange={(e) => setPasswordData(prev => ({ ...prev, confirmPassword: e.target.value }))}
                  placeholder="새 비밀번호를 다시 입력하세요"
                  isInvalid={!!errors.confirmPassword}
                />
                <Button
                  variant="link"
                  className="position-absolute end-0 top-0 border-0 bg-transparent"
                  style={{ zIndex: 10 }}
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  <i className={`fas ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </Button>
              </div>
              <Form.Control.Feedback type="invalid">
                {errors.confirmPassword}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPasswordChangeModal(false)}>
            취소
          </Button>
          <Button variant="primary" onClick={handlePasswordChange}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Login;
